import { requiredField } from './fields.js';
import {
  GenericFormData,
  RepeatedValidationFieldConfig,
  ValidationConfig,
  ValidationFieldConfig,
} from './types.js';

export default function buildCompleteConfig<FormData extends GenericFormData>(
  initialState: FormData,
  config: ValidationConfig<FormData> = {},
): ValidationConfig<FormData> {
  return {
    ...config,
    ...Object.keys(initialState).reduce(
      (map, key: keyof FormData) => {
        let field: ValidationFieldConfig<FormData>;
        if (!Array.isArray(initialState[key]) || config[key]?.type === 'simple') {
          field = config[key] ?? requiredField();
        } else {
          const fieldConfig = config[key] as RepeatedValidationFieldConfig<FormData, typeof key>;
          field = {
            required: true,
            ...fieldConfig,
            schema: {
              ...(initialState[key].length > 0 ? buildCompleteConfig(initialState[key][0]) : {}),
              ...fieldConfig?.schema,
            },
            type: 'repeated',
          };
        }

        map[key] = field;
        return map;
      },
      {} as ValidationConfig<FormData>,
    ),
  };
}
